import { ContainerLayoutType, LayoutBlockType } from '@/types';
export const getContainerChildren = (block) => {
    if (block.layout_config.type === ContainerLayoutType.COLUMNS) {
        return block.layout_config.columns.flatMap((column) => column.blocks);
    }
    return block.layout_config.blocks;
};
export const flattenBlocks = (blocks) => {
    return blocks.flatMap((block) => {
        if (block.type !== LayoutBlockType.LAYOUT_CONTAINER) {
            return [block];
        }
        return [block, ...flattenBlocks(getContainerChildren(block))];
    });
};
